import { useLocation } from "react-router-dom";
import { useRecordNavigation } from "@jkast90/kast-common/diagnostics/react";

/**
 * The screen history a bug report carries: one entry per section, on every
 * change of location, so deep links and back/forward count too. Mounted once
 * inside the router, above the routes, so it covers the player as well.
 */
export default function NavRecorder() {
  useRecordNavigation(useLocation().pathname);
  return null;
}
